import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Image, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import AppStorage from 'AppStorage';
import { PolicyPayload, UtmSource } from 'Constants';
import { AppContext } from 'context/app-context';
import logo from 'images/fwd_logo.png';
import AIBLogo from 'images/big3Product/AEON INSURANCE BROKERS.png';
import Network from 'services/Network';

import styles from './NavigationBar.module.css';

NavigationBar.propTypes = {
  canBack: PropTypes.bool,
  backPath: PropTypes.string,
  logoLink: PropTypes.string,
  secondLogo: PropTypes.string,
  secondLogoUrl: PropTypes.string,
  showLanguageSwitch: PropTypes.bool,
  canCancel: PropTypes.bool
};

function NavigationBar(props) {
  const {
    canBack,
    backPath,
    logoLink,
    secondLogo,
    secondLogoUrl,
    showLanguageSwitch,
    canCancel
  } = props;
  const { t } = useTranslation('shared');
  const context = useContext(AppContext);
  const network = new Network();
  const [showPaymentPartner, setShowPaymentPartner] = useState(false);
  const pathname = window.location.pathname;

  const partnerParamSrc = new URLSearchParams(window.location.search).get('partner_source');
  const utmParamSrc = new URLSearchParams(window.location.search).get('utm_source');
  const big3Product = '/direct/big-3-critical-illness';
  const termLife = '/direct/protect-direct';

  useEffect(() => {
    if (partnerParamSrc) {
      setShowPaymentPartner(true);
    }
  }, [partnerParamSrc]);

  const handleClickBack = () => {
    if (backPath) {
      // Not using props.history since it can be null for direct URL access
      window.location = backPath;
    } else {
      window.history.back();
    }
  };

  // AEON Insurance Brokers
  const isShowAIB = () =>
    pathname.includes(big3Product) && utmParamSrc && utmParamSrc.toUpperCase() === UtmSource.AIB;

  const handleClickCancel = async () => {
    const response = await network.navigateToIProtect(
      'A',
      '',
      AppStorage.getItem(PolicyPayload)?.payLoad?.policySettingDto?.utmParam?.utmCampaign ?? ''
    );
    console.log('===response navigate to protect===', response);
  };

  const renderSecondLogo = () => {
    console.log('|||renderSecondLogo|||');
    const secondaryLogoProps = {
      alt: 'company-logo',
      src: secondLogo,
      width: '95%',
      className: 'd-inline-block align-top'
    };
    if (secondLogo) {
      return (
        <>
          <div className={styles.logoSeparator} />
          <a href={secondLogoUrl ? secondLogoUrl : '#'}>
            <Image {...secondaryLogoProps} alt="company-logo" />
          </a>
        </>
      );
    }

    if (isShowAIB()) {
      return (
        <>
          <div className={styles.logoSeparator} />
          <a href="https://aeoninsurance.com.my/family-takaful/">
            <Image src={AIBLogo} width={46} className={styles.AIBLogo} alt="company-logo" />
          </a>
        </>
      );
    }
  };

  const renderLanguageSwitch = () => {
    if (showLanguageSwitch) {
      return (
        <>
          <Navbar.Text className={context.lng === 'en' ? styles.languageActive : styles.language}>
            <Link onClick={() => context.changeLanguage('en')} to={'#'}>
              English
            </Link>
          </Navbar.Text>
          <Navbar.Text className={styles.languageSeparator}> | </Navbar.Text>
          <Navbar.Text className={context.lng === 'ms' ? styles.languageActive : styles.language}>
            <Link onClick={() => context.changeLanguage('ms')} to={'#'}>
              Bahasa
            </Link>
          </Navbar.Text>
        </>
      );
    }
  };

  const backButton = () => {
    if (canBack) {
      return (
        <Button variant="link" onClick={handleClickBack} className={styles.navbarLink}>
          <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {t('back')}
        </Button>
      );
    }
  };

  const cancelButton = () => {
    if (canCancel) {
      return (
        <Button onClick={handleClickCancel} className={styles.cancelButton}>
          {t('cancel')}
        </Button>
      );
    }
  };

  // const checkShowPaymentPartner = () => {
  //   const partnerPayload = AppStorage.getItem(PartnerPayload);
  //   if (partnerPayload?.partnerSource === "hsbc" && partnerPayload?.bin) {
  //     setShowPaymentPartner(true);
  //   }
  // };

  const renderRightNavSentence = () => {
    if (showPaymentPartner && (pathname.includes(termLife) || pathname.includes(big3Product))) {
      return (
        <div className="justify-content-end">
          <span className={styles.navRight}>Distributed by</span>
          <br />
          <span className={styles.navRight}>HSBC Amanah Malaysia Berhad</span>
        </div>
      );
    }

    if (isShowAIB()) {
      return (
        <div className="justify-content-end">
          <div className={styles.aibSmallText}>Distributed By:</div>
          <div className={styles.aibBigText}>AEON INSURANCE BROKERS (M) SDN. BHD.</div>
          <div className={styles.aibSmallText}>Tel No: +603-2772-9688</div>
        </div>
      );
    }
  };

  const imgProps = {
    alt: 'company-logo',
    src: logo,
    width: 100,
    className: 'd-inline-block align-top'
  };

  return (
    <Navbar variant="dark" expand="lg" className={styles.navigationBar}>
      <Navbar.Brand className={styles.navBarBrand}>
        <Link to={logoLink ? logoLink : '/direct/protect-direct'}>
          <Image {...imgProps} alt="company-logo" />
        </Link>
        {renderSecondLogo()}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse className="justify-content-end" id="responsive-navbar-nav">
        {renderRightNavSentence()}
        {!showPaymentPartner && (
          <>
            {renderLanguageSwitch()}
            <Navbar.Text>{backButton()}</Navbar.Text>
            {cancelButton()}
          </>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavigationBar;
